/*
  Gymnastics Forza Reels (sostituto di ReelUp), codice del tema: nessuna app esterna.
  - Galleria: le anteprime corte si caricano poco prima di entrare nello schermo e partono mute
    quando sono visibili. Il video compare solo quando ha davvero un'immagine (mai riquadri neri).
  - Lettore a tutto schermo, scorrimento verticale stile TikTok:
    * sotto ogni video c'e' sempre la copertina, quindi scorrendo veloce non si vede mai il nero;
    * il video corrente parte subito, il precedente e i due successivi sono gia' pronti;
    * i video lontani vengono liberati, cosi' il telefono resta veloce anche con 90 video;
    * streaming adattivo HLS (nativo su iPhone, hls.js caricato solo al primo tocco altrove).
  Nessuna statistica inviata a terzi.
*/
(function () {
  if (window.gfReelsReady) return;
  window.gfReelsReady = true;

  var HLS_LIB = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.15/dist/hls.light.min.js';
  var KEEP_BEHIND = 1;
  var KEEP_AHEAD = 2;
  var isThai = (document.documentElement.lang || '').indexOf('th') === 0;
  var T = isThai
    ? { close: 'ปิด', sound: 'เสียง', next: 'ปัดขึ้นเพื่อดูวิดีโอถัดไป' }
    : { close: 'Close', sound: 'Sound', next: 'Swipe up for the next video' };

  /* ---------- Galleria ---------- */
  function markReady(card, video) {
    video.addEventListener('playing', function () { card.classList.add('is-playing'); });
  }

  var loadObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target.querySelector('video');
        if (video && !video.src) {
          video.preload = 'auto';
          video.src = video.dataset.src;
        }
        loadObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '200px 400px' }
  );

  var playObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          if (!video.src) video.src = video.dataset.src;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.55 }
  );

  /* Galleria "a pila" (schede prodotto, come ReelUp sull'intl): la card piu' vicina al centro e' quella attiva */
  function bindStack(root, cards) {
    var track = root.querySelector('.gf-reels__track');
    var prev = root.querySelector('[data-gf-step="-1"]');
    var next = root.querySelector('[data-gf-step="1"]');
    root._active = 0;
    function update() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      root._active = best;
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === best); });
      if (prev) prev.disabled = best === 0;
      if (next) next.disabled = best === cards.length - 1;
    }
    root._go = function (i) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      track.scrollTo({ left: card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2, behavior: 'smooth' });
    };
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; update(); }, 60);
    }, { passive: true });
    [prev, next].forEach(function (btn) {
      if (btn) btn.addEventListener('click', function () { root._go(root._active + Number(btn.dataset.gfStep)); });
    });
    update();
  }

  function bindGallery(root) {
    if (root.dataset.gfBound) return;
    root.dataset.gfBound = '1';
    var cards = root.querySelectorAll('.gf-reel');
    var isStack = root.classList.contains('gf-reels--stack');
    cards.forEach(function (card, i) {
      markReady(card, card.querySelector('video'));
      loadObserver.observe(card);
      playObserver.observe(card);
      card.addEventListener('click', function (event) {
        /* il BUY NOW e' un link normale: non apre il lettore */
        if (event.target.closest('.gf-reel__buy')) return;
        /* nella pila, toccare una card laterale la porta al centro */
        if (isStack && i !== root._active) { root._go(i); return; }
        openPlayer(cards, Number(card.dataset.index));
      });
    });
    if (isStack) bindStack(root, cards);
  }

  function scan() {
    document.querySelectorAll('[data-gf-reels]').forEach(bindGallery);
  }

  /* ---------- Streaming ---------- */
  var hlsPromise = null;
  function loadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsPromise) return hlsPromise;
    hlsPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = HLS_LIB;
      s.async = true;
      s.onload = function () { resolve(window.Hls || null); };
      s.onerror = function () { resolve(null); };
      document.head.appendChild(s);
    });
    return hlsPromise;
  }

  var nativeHls = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';
  /* come YouTube: hls.js parte dal 480p e sale da solo, anche su iPhone (iOS 17.1+ ha ManagedMediaSource).
     L'HLS nativo di Safari partiva dal 1080p e si bloccava (Martin, 2 nov 2026): resta solo se hls.js non puo' andare. */
  var canMse = !!(window.ManagedMediaSource || window.MediaSource);

  /* se hls.js non va: streaming nativo dove c'e' (iPhone), altrimenti l'mp4 */
  function fallback(slide) {
    var video = slide._video;
    video.src = nativeHls ? slide.dataset.hls : slide.dataset.mp4;
    if (slide === slides[current]) video.play().catch(function () {});
  }

  function attach(slide) {
    if (slide._attached) return;
    slide._attached = true;
    var video = slide._video;
    var hlsUrl = slide.dataset.hls;
    var mp4Url = slide.dataset.mp4;
    if (!hlsUrl) {
      video.src = mp4Url;
      return;
    }
    video.preload = 'auto';
    if (nativeHls && !canMse) {
      video.addEventListener('error', function onError() {
        video.removeEventListener('error', onError);
        if (slide._attached && video.src !== mp4Url) {
          video.src = mp4Url;
          if (slide === slides[current]) video.play().catch(function () {});
        }
      });
      video.src = hlsUrl;
      return;
    }
    loadHls().then(function (Hls) {
      if (!slide._attached) return;
      if (Hls && Hls.isSupported()) {
        /* parte dalla qualita' piu' leggera (avvio immediato) e sale da sola se la connessione regge;
           se un pezzo non arriva in 4 s (CDN Shopify lento la prima volta) lo richiede subito */
        video.disableRemotePlayback = true; /* richiesto da ManagedMediaSource su iPhone */
        var hls = new Hls({ capLevelToPlayerSize: true, startLevel: 0, abrEwmaDefaultEstimate: 1500000, maxBufferLength: 10, backBufferLength: 5, fragLoadPolicy: { default: { maxTimeToFirstByteMs: 4000, maxLoadTimeMs: 12000, timeoutRetry: { maxNumRetry: 6, retryDelayMs: 0, maxRetryDelayMs: 0 }, errorRetry: { maxNumRetry: 6, retryDelayMs: 500, maxRetryDelayMs: 4000 } } } });
        hls.loadSource(hlsUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.ERROR, function (event, data) {
          if (!data.fatal || slide._hls !== hls) return;
          hls.destroy();
          slide._hls = null;
          fallback(slide);
        });
        slide._hls = hls;
        if (slide === slides[current]) video.play().catch(function () {});
      } else {
        fallback(slide);
      }
    });
  }

  function detach(slide) {
    if (!slide._attached) return;
    slide._attached = false;
    var video = slide._video;
    video.pause();
    if (slide._hls) {
      slide._hls.destroy();
      slide._hls = null;
    }
    video.removeAttribute('src');
    video.load();
    slide.classList.remove('is-ready', 'is-waiting');
  }

  /* ---------- Lettore a tutto schermo ---------- */
  var player = null;
  var list = null;
  var slides = [];
  var current = -1;
  var muted = false;

  function playCurrent() {
    var slide = slides[current];
    if (!slide) return;
    attach(slide);
    var video = slide._video;
    video.muted = muted;
    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        /* il browser blocca l'audio: riparte muto, l'utente puo' riattivarlo */
        muted = true;
        video.muted = true;
        updateSoundButton();
        video.play().catch(function () {});
      });
    }
  }

  var neighborTimer = null;
  function setCurrent(index) {
    if (index === current || !slides[index]) return;
    if (slides[current]) slides[current]._video.pause();
    current = index;
    slides.forEach(function (slide, i) {
      var near = i >= index - KEEP_BEHIND && i <= index + KEEP_AHEAD;
      var far = i < index - KEEP_BEHIND - 1 || i > index + KEEP_AHEAD + 1;
      if (near && i === index) attach(slide);
      else if (far) detach(slide);
      if (i !== index && slide._attached) slide._video.pause();
      /* copertine pronte attorno alla posizione attuale */
      if (Math.abs(i - index) <= 6 && slide._img.loading !== 'eager') slide._img.loading = 'eager';
    });
    playCurrent();
    /* i video vicini si preparano dopo: il tocco sul video e sulla X resta immediato */
    clearTimeout(neighborTimer);
    neighborTimer = setTimeout(function () {
      slides.forEach(function (slide, i) {
        if (i !== current && i >= current - KEEP_BEHIND && i <= current + KEEP_AHEAD) { attach(slide); slide._video.pause(); }
      });
    }, 900);
  }

  /* calcolo immediato a ogni movimento: anche scorrendo velocissimo il video giusto e' sempre pronto */
  var settleTimer = null;
  function onScroll() {
    var h = list.clientHeight || 1;
    var index = Math.round(list.scrollTop / h);
    if (index !== current) setCurrent(index);
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      var settled = Math.round(list.scrollTop / h);
      if (settled !== current) setCurrent(settled);
      else if (slides[current] && slides[current]._video.paused) playCurrent();
    }, 140);
  }

  function updateSoundButton() {
    if (player) player.querySelector('[data-gf-sound]').classList.toggle('is-muted', muted);
  }

  function buildPlayer() {
    player = document.createElement('div');
    player.className = 'gf-player';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.innerHTML =
      '<div class="gf-player__list"></div>' +
      '<div class="gf-player__bar">' +
      '<button type="button" class="gf-player__btn" data-gf-sound aria-label="' + T.sound + '">' +
      '<svg viewBox="0 0 24 24" class="on"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/></svg>' +
      '<svg viewBox="0 0 24 24" class="off"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="m17 9 5 6M22 9l-5 6"/></svg>' +
      '</button>' +
      '<button type="button" class="gf-player__btn" data-gf-close aria-label="' + T.close + '"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>' +
      '<p class="gf-player__hint">' + T.next + '</p>';
    document.body.appendChild(player);
    list = player.querySelector('.gf-player__list');
    list.addEventListener('scroll', onScroll, { passive: true });
    player.querySelector('[data-gf-close]').addEventListener('click', closePlayer);
    player.querySelector('[data-gf-sound]').addEventListener('click', function () {
      muted = !muted;
      if (slides[current]) slides[current]._video.muted = muted;
      updateSoundButton();
    });
    document.addEventListener('keydown', function (event) {
      if (!player.classList.contains('is-open')) return;
      if (event.key === 'Escape') closePlayer();
      if (event.key === 'ArrowDown' && slides[current + 1]) slides[current + 1].scrollIntoView({ behavior: 'smooth' });
      if (event.key === 'ArrowUp' && slides[current - 1]) slides[current - 1].scrollIntoView({ behavior: 'smooth' });
    });
  }

  function makeSlide(card, i, start) {
    var slide = document.createElement('div');
    slide.className = 'gf-player__slide';
    slide.dataset.hls = card.dataset.hls || '';
    slide.dataset.mp4 = card.dataset.mp4 || '';
    var img = document.createElement('img');
    img.className = 'gf-player__poster';
    img.alt = '';
    img.decoding = 'async';
    img.loading = Math.abs(i - start) <= 6 ? 'eager' : 'lazy';
    img.src = card.dataset.poster;
    var video = document.createElement('video');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    video.preload = 'none';
    var spinner = document.createElement('span');
    spinner.className = 'gf-player__spin';
    slide.appendChild(img);
    slide.appendChild(video);
    slide.appendChild(spinner);
    slide._img = img;
    slide._video = video;
    video.addEventListener('playing', function () { slide.classList.add('is-ready'); slide.classList.remove('is-waiting'); });
    video.addEventListener('waiting', function () { slide.classList.add('is-waiting'); });
    video.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    return slide;
  }

  function openPlayer(cards, start) {
    if (!player) buildPlayer();
    slides.forEach(detach);
    list.innerHTML = '';
    slides = [];
    current = -1;
    Array.prototype.forEach.call(cards, function (card, i) {
      var slide = makeSlide(card, i, start);
      list.appendChild(slide);
      slides.push(slide);
    });
    document.querySelectorAll('[data-gf-reels] video').forEach(function (v) { v.pause(); });
    player.classList.add('is-open');
    document.documentElement.classList.add('gf-player-open');
    list.scrollTop = start * list.clientHeight;
    /* il tocco dell'utente permette l'audio sul primo video */
    setCurrent(start);
  }

  function closePlayer() {
    if (!player) return;
    /* prima si chiude lo schermo (subito), poi si liberano i video */
    player.classList.remove('is-open');
    document.documentElement.classList.remove('gf-player-open');
    clearTimeout(neighborTimer);
    var old = slides;
    slides = [];
    current = -1;
    old.forEach(function (slide) { slide._video.pause(); });
    setTimeout(function () {
      old.forEach(detach);
      if (!player.classList.contains('is-open')) list.innerHTML = '';
    }, 60);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
